export type TransferPerson = { id: string; name: string; username: string | null };
export type TransferReceipt = {
  id: string; commandId: string; amountMicros: string; direction: "sent" | "received";
  sender: TransferPerson; recipient: TransferPerson; completedAt: string;
};
export type TransferOverview = {
  userId: string; totalMicros: string; transferableMicros: string; receivedMicros: string;
  directCount: number; history: TransferReceipt[];
};
export type TransferRecipients = { recipients: TransferPerson[]; next: string | null };
export function rewardTransferRequestPath(path: string): string {
  const url = new URL(path, "https://transfer.invalid");
  if (!path.startsWith("/") || url.origin !== "https://transfer.invalid" || url.hash ||
    !/^\/(?:recipients|commands\/[a-zA-Z0-9:_-]{16,128})?$/.test(url.pathname)) throw new Error("transfer_path_invalid");
  return (url.pathname === "/" ? "" : url.pathname) + url.search;
}
export function parseTransferMicros(text: string): string | null {
  const value = text.trim().replace(",", ".");
  if (!/^\d{1,26}(?:\.\d{1,6})?$/.test(value)) return null;
  const [whole = "0", fraction = ""] = value.split(".");
  const amount = BigInt(whole) * 1000000n + BigInt(fraction.padEnd(6, "0"));
  return amount > 0n ? amount.toString() : null;
}
export function editableTransferAmount(micros: string): string {
  const value = BigInt(micros);
  return `${value / 1000000n}.${(value % 1000000n).toString().padStart(6, "0")}`.replace(/\.?0+$/, "");
}
